import React, { useState, useEffect, useContext } from "react";
import PersistentDataGrid from "../../components/PersistentDataGrid";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import styled from "styled-components";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AlertDialog from "../../components/AlertDialog.js";

import TeamResourcesDialog from "./TeamResourcesDialog.js";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { GET_TEAM_ALL_TERMS } from "../../graphQL/team_term_qry";
import { GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY } from "../../graphQL/team_term_member_qry";

import Header from "./Header.js";
import EditTeamTermNotesDialog from "./EditTeamTermNotesDialog";
import { project_url } from "../../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function TeamTermsList() {
  const classes = useStyles();
  const navigate = useNavigate();
  const client = useContext(ClientContext);
  const { teamUuid } = useParams();
  const [pathname] = useState(window.location.pathname);
  const [rows, setRows] = useState([]);
  const [teamName, setTeamName] = useState("");
  const [loadContent, setLoadContent] = useState(false);
  const [openTeamResourcesDlg, setOpenTeamResourcesDlg] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [resourcesList, setResourcesList] = useState([]);
  const [alertMsg, setAlertMsg] = useState([]);

  const [currentTeamTermData, setCurrentTeamTermData] = useState([]);
  const [openEditTeamTermNotesDialog, setOpenEditTeamTermNotesDialog] = useState(false);
  const [termsAccess , setTermsAccess ] = useState(true)

  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    let newFormat = "-";
    if (day) {
      const dayDate = new Date(day);
      const dayFormat = formatter.formatToParts(dayDate);
      newFormat =
        dayFormat.find(a => a.type == "month").value +
        "/" +
        dayFormat.find(a => a.type == "day").value +
        "/" +
        dayFormat.find(a => a.type == "year").value;
    }
    return newFormat;
  };

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Teams",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
           
      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');
      
      
      if(additionalActions.find(a => a == "Terms")){
        setTermsAccess(true);}
      else setTermsAccess(false)


      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);


  const [getTeamAllTermsListQuery] = useManualQuery(GET_TEAM_ALL_TERMS);
  const [getTeamTermMemberList] = useManualQuery(GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY);

  const getTeamAllTermsList = async () => {
    const {
      loading: termsListLoading,
      error: termsListError,
      data: termsListData,
    } = await getTeamAllTermsListQuery({
      variables: {
        teamUuid: teamUuid,
      },
    });
    if (!termsListLoading && termsListData && termsListData.getTeamAllTerms) {
      setRows(
        termsListData.getTeamAllTerms.map(teamTerm => ({
          id: teamTerm.teamTermId,
          termUuid: teamTerm.termId.termUuid,
          termName: teamTerm.termId.name,
          goal: teamTerm.goal,
          startDate: teamTerm.termId.startDate
            ? dayFormat(teamTerm.termId.startDate)
            : "",
          endDate: teamTerm.termId.endDate ? dayFormat(teamTerm.termId.endDate) : "",
          noOfWeeks: teamTerm.noOfWeeks,
          current: teamTerm.termId.current,
          teamName: teamTerm.teamId.name,

          notes: teamTerm.note,
          noOfResources: teamTerm.noOfResources,
        }))
      );
      termsListData &&
        termsListData.getTeamAllTerms.length &&
        setTeamName(termsListData.getTeamAllTerms[0].teamId.name);
    }
    if (termsListError) {
      // if (termsListError.graphQLErrors[0].message === "Signature has expired")
      navigate(`${project_url}/signin`);
    }
  };

  const getAllTeamTermMembers = async () => {
    if (selectedRow && selectedRow.id) {
      const {
        loading: loadingGetTeamTermMember,
        error: errorGetTeamTermMember,
        data: dataGetTeamTermMember,
      } = await getTeamTermMemberList({
        variables: {
          teamTermId: parseInt(selectedRow.id),
        },
      });
      if (
        !loadingGetTeamTermMember &&
        dataGetTeamTermMember &&
        dataGetTeamTermMember.getAllMembersInTeamTerm
      ) {
        setResourcesList(dataGetTeamTermMember.getAllMembersInTeamTerm);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTeamAllTermsList())();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getAllTeamTermMembers())();
  }, [selectedRow]);

  const handleTeamResourceClick = row => {
    setSelectedRow(row);
    setOpenTeamResourcesDlg(true);
  };

  const handleTeamResourceClose = () => {
    setSelectedRow(null);
    setOpenTeamResourcesDlg(false);
  };

  const columns = [
    {
      field: "termName",
      headerName: "Term Name",
      minWidth: 130,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return rows.row.current ? (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="This is the current term">
              <Typography variant="h3" style={{ fontSize: 14, marginTop: 15 }}>
                {rows.row.termName}
              </Typography>
            </StyledTooltip>
          </Box>
        ) : (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {rows.row.termName}
          </Box>
        );
      },
    },
    {
      field: "goal",
      headerName: "Team Term Goal ",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "noOfWeeks",
      headerName: "No of Weeks",
      minWidth: 80,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "noOfResources",
      headerName: "No of Resources",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 150,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="Notes">
              <EditNoteIcon
                color="action"
                style={{
                  paddingRight: 8,
                  paddingTop: 13,
                  cursor: "pointer",
                  // fontSize: 24,
                }}
                onClick={() => {
                  setCurrentTeamTermData(rows.row);
                  setOpenEditTeamTermNotesDialog(true);
                }}
              />
            </StyledTooltip>

            <StyledTooltip title="Activities">
              <IconButton>
                <CalendarMonthOutlinedIcon
                  onClick={() =>
                    navigate(`${project_url}/teams/${teamUuid}/team-term/${rows.row.termUuid}`, {
                      state: rows.row,
                    })
                  }
                />
              </IconButton>
            </StyledTooltip>
            <StyledTooltip title="Team Resources">
              <IconButton>
                <Diversity1Icon onClick={() => handleTeamResourceClick(rows.row)} />
              </IconButton>
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 20,
            paddingBottom: 15,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Team Terms List
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          ></Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  if (loadContent)
    if (termsAccess)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: teamName, link: null },
            { label: "Team Terms List", link: null },
          ]}
        />
        <div className={classes.container}>
          <PersistentDataGrid
            persistenceKey="team_terms-list"
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            // hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.id}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
              // sorting: {
              //   sortModel: [{ field: "endDate", sort: "desc" }],
              // },
            }}
            pageSizeOptions={[10, 25, 50]}
            getRowClassName={params => (params.row.current ? "current-row" : "")}
          />
          <style>
            {`
              .current-row {
                background-color: rgba(203, 255, 139, 0.33) !important; /* Light green */
              }
            `}
          </style>
        </div>
        {openTeamResourcesDlg && (
          <TeamResourcesDialog
            selectedRow={selectedRow}
            resourcesList={resourcesList}
            closeDialog={handleTeamResourceClose}
          />
        )}
        {openEditTeamTermNotesDialog && (
          <EditTeamTermNotesDialog
            teamTermId={currentTeamTermData.id}
            closeDialog={() => {
              setOpenEditTeamTermNotesDialog(false);
            }}
          />
        )}
      </div>
    );
    else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default TeamTermsList;
